import { inject, Pipe, PipeTransform } from '@angular/core'

import { TranslateArgs, TranslatorService } from 'app/core/i18n/translator.service'

@Pipe({ name: 'translate', pure: true, standalone: true })
export class TranslatePipe implements PipeTransform {
  private readonly translator = inject(TranslatorService)

  transform(itemKey: string, arg?: TranslateArgs): string {
    return this.translator.get(itemKey, arg)
  }
}
